import FormikDropdown from "common/components/FormikFields/FormikDropdown"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import usePoblaciones from "common/hooks/usePoblaciones"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

interface DireccionInputsProps {
  disabled?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFieldValue: (...args: any[]) => any
  cpId?: string
  cpName?: string
  cpValue: string // Cambia el tipo según lo que necesites
  poblacionId?: string
  poblacionName?: string
  poblacionValue: string
  provinciaId?: string
  provinciaName?: string
  provinciaValue?: string
  initialCodigoPostal: string
  showProvincia?: boolean
  otherCountries?: boolean
  className?: string
  countrySelected?: string
}
const DireccionInputs = ({
  disabled = false,
  setFieldValue,
  cpId = "cpId",
  cpName = "cp",
  cpValue,
  poblacionId = "poblacionId",
  poblacionName = "poblacion",
  poblacionValue,
  provinciaId = "provinciaId",
  provinciaName = "provincia",
  provinciaValue,
  initialCodigoPostal,
  showProvincia = false,
  otherCountries = false,
  className,
  countrySelected,
}: DireccionInputsProps) => {
  const { t } = useTranslation()
  const {
    getPoblacionByName,
    poblacionesOptions,
    provinciasOptions,
    fetchPoblacionesByCodigoPostal,
  } = usePoblaciones({
    initialCodigoPostal,
  })

  const handleOnChangeCp = async (e: $TSMigrationFixMe) => {
    if (countrySelected !== DEFAULT_COUNTRY_SELECTED) {
      setFieldValue(cpName, e.target.value)

      return
    }

    const value = `${e.target.value.replace(/[^0-9]/g, "")}`

    setFieldValue(cpName, value)
    if (value.length === 5) {
      const res = await fetchPoblacionesByCodigoPostal(value)

      if (res?.length) {
        const {
          nombre,
          id,
          provinciaNombre,
          provinciaId: provId,
          codigosPostales,
        } = res[0]

        setFieldValue(cpId, codigosPostales?.[0]?.id)
        setFieldValue(poblacionId, id)
        setFieldValue(poblacionName, nombre)
        setFieldValue(provinciaName, provinciaNombre)
        setFieldValue(provinciaId, provId)
      }
    } else {
      setFieldValue(poblacionId, "")
      setFieldValue(provinciaId, "")
      setFieldValue(poblacionName, "")
      setFieldValue(provinciaName, "")
    }
  }

  const handleChangePoblacion = ({ value }: $TSMigrationFixMe) => {
    setFieldValue(poblacionName, value)
    const {
      // @ts-expect-error TS(2339): Property 'provinciaNombre' does not exist on type ...
      provinciaNombre,
      // @ts-expect-error TS(2339): Property 'provinciaId' does not exist on type 'und...
      provinciaId: provId,
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'undefined'.
      id,
      // @ts-expect-error TS(2339): Property 'codigosPostales' does not exist on type ...
      codigosPostales,
    } = getPoblacionByName(value)
    setFieldValue(cpId, codigosPostales?.[0]?.id)
    setFieldValue(provinciaName, provinciaNombre)
    setFieldValue(provinciaId, provId)
    setFieldValue(poblacionId, id)
  }

  return (
    <div
      className={`tw-w-full tw-grid ${
        showProvincia ? "tw-grid-cols-3 " : "tw-grid-cols-2"
      } tw-gap-4`}
    >
      <div className={`tw-mb-4 ${className}`}>
        <label
          htmlFor={cpName}
          className='tw-block'
        >
          {t("perfilEmpresa.directions.labelZipCode")}
        </label>

        <FormikInputText
          disabled={disabled}
          onChange={handleOnChangeCp}
          id={cpName}
          name={cpName}
          value={cpValue}
          className='tw-w-full !tw-rounded'
        />
      </div>

      {showProvincia && (
        <div className={`${className}`}>
          <label
            htmlFor={provinciaName}
            className='tw-block'
          >
            {t("perfilEmpresa.directions.labelProvince")}
          </label>

          <FormikDropdown
            placeholder={
              provinciasOptions?.length
                ? `${t("perfilEmpresa.directions.placeholderProvince")}`
                : `${t("perfilEmpresa.directions.placeholderZipCode")}`
            }
            disabled={!provinciasOptions?.length}
            id={provinciaName}
            name={provinciaName}
            options={provinciasOptions}
            value={provinciaValue}
            className='tw-w-full !tw-rounded'
          />
        </div>
      )}

      <div className={`${className}`}>
        <label
          htmlFor={poblacionId}
          className='tw-block'
        >
          {t("perfilEmpresa.directions.labelTown")}
        </label>

        {!otherCountries ? (
          <FormikDropdown
            placeholder={
              poblacionesOptions?.length
                ? `${t("perfilEmpresa.directions.placeholderTown")}`
                : `${t("perfilEmpresa.directions.placeholderIntProvince")}`
            }
            disabled={!poblacionesOptions?.length || disabled}
            id={poblacionName}
            name={poblacionName}
            options={poblacionesOptions}
            onChange={handleChangePoblacion}
            showOnFocus
            value={poblacionValue}
            className='tw-w-full !tw-rounded'
            panelClassName='!tw-z-[2302]'
          />
        ) : (
          <FormikInputText
            disabled={disabled}
            name='poblacionExtranjera'
            onChange={(ev: $TSMigrationFixMe) => {
              setFieldValue("poblacionExtranjera", ev.target.value)
            }}
            className='tw-w-full !tw-rounded'
          />
        )}
      </div>
    </div>
  )
}

DireccionInputs.propTypes = {
  setFieldValue: PropTypes.func,
  cpId: PropTypes.string,
  poblacionId: PropTypes.string,
  cpName: PropTypes.string,
  poblacionName: PropTypes.string,
  provinciaName: PropTypes.string,
  initialCodigoPostal: PropTypes.any,
}

export default DireccionInputs
